import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface DeletionRequest {
    id?: string;
    usernameAtDeletion?: string;
    emailAtDeletion?: string;
    deletionStatus?: number;
    scheduledDeletionDate?: string;
    creationDate?: string;
}

export interface DeletionResponse {
    requests?: DeletionRequest[];
    count?: number;
}

export class AccountDeletionHandler {
    async getDeletionRequests(
        statusFilter: number | null,
        page: number,
        pageSize: number
    ): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const params = new URLSearchParams();
        if (statusFilter !== null) params.append('StatusFilter', statusFilter.toString());
        params.append('PageNumber', page.toString());
        params.append('AmountPerPage', pageSize.toString());
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/GetDeletionRequests?${params.toString()}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

}
